import React, { useState } from "react";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";

function Reproducibility_table() {
  const data = [
    {
      parameter: "IM",
      certifiedValue: "3.25",
      avg: "6.50",
      sd: "0.07",
      rsd: "0.26%",
      rows: [
        {
          performedBy: "Rakesh Shaha",
          method: "IS 1350 Part-I",
          day: "DAY 01",
          value: "3.30",
        },
        {
          performedBy: "Rashid Khan",
          method: "IS 1350 Part-I",
          day: "DAY 02",
          value: "3.30",
        },
        {
          performedBy: "Shubham Patil",
          method: "IS 1350 Part-II",
          day: "DAY 03",
          value: "3.30",
        },
        {
          performedBy: "Rakesh Shaha",
          method: "IS 1350 Part-II",
          day: "DAY 04",
          value: "3.30",
        },
      ],
    },

    {
      parameter: "IM",
      certifiedValue: "3.25",
      avg: "6.50",
      sd: "0.07",
      rsd: "0.26%",
      rows: [
        {
          performedBy: "Rakesh Shaha",
          method: "IS 1350 Part-I",
          day: "DAY 01",
          value: "3.30",
        },
        {
          performedBy: "Rashid Khan",
          method: "IS 1350 Part-I",
          day: "DAY 02",
          value: "3.30",
        },
        {
          performedBy: "Shubham Patil",
          method: "IS 1350 Part-II",
          day: "DAY 03",
          value: "3.30",
        },
        {
          performedBy: "Rakesh Shaha",
          method: "IS 1350 Part-II",
          day: "DAY 04",
          value: "3.30",
        },
      ],
    },
  ];


     const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th rowSpan="2">Test Parameter</th>
                  <th rowSpan="2">Certified Value</th>
                  <th rowSpan="2">Test Performed By</th>
                  <th rowSpan="2">Test Method</th>
                  <th colSpan="2" className="text-center">
                    Observations
                  </th>
                  <th rowSpan="2">Avg.</th>
                  <th rowSpan="2">SD</th>
                  <th rowSpan="2">RSD%</th>
                </tr>
                <tr>
                  <th>DAY</th>
                  <th>VALUE</th>
                </tr>
              </thead>

              <tbody>
                {data.map((item, index) =>
                  item.rows.map((row, rowIndex) => (
                            <tr key={`${index}-${rowIndex}`}>
                              {/* Test Parameter + Certified Value */}
                              {rowIndex === 0 && (
                                <>
                                  <td rowSpan={item.rows.length}>
                                    {item.parameter}
                                  </td>
                                  <td rowSpan={item.rows.length}>
                                    {item.certifiedValue}
                                  </td>
                                </>
                              )}

                              {/* Regular row data */}
                              <td>{row.performedBy}</td>
                              <td>{row.method}</td>
                              <td>{row.day}</td>
                              <td>{row.value}</td>

                              {/* Avg / SD / RSD */}
                              {rowIndex === 0 && (
                                <>
                                  <td rowSpan={item.rows.length}>{item.avg}</td>
                                  <td rowSpan={item.rows.length}>{item.sd}</td>
                                  <td rowSpan={item.rows.length}>{item.rsd}</td>
                                </>
                              )}
                            </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <div className="note_text_holder">
        <p>* Results Are In Air Dried Basis.</p>
      </div>

       <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
}

export default Reproducibility_table;
